module.exports = __webpack_public_path__ + "c3b8be5174a4a724673ecc034e205c35.png";